import type { IJobScheduleOptions } from '@/interfaces'
import type { ITimeBasedTrigger } from '@/interfaces/jobs/ITimeBasedTrigger'
import TimeBasedTrigger from './TimeBasedTrigger'
import type { IValueBasedTrigger } from '@/interfaces/jobs/IValueBasedTrigger'
import ValueBasedTrigger from './ValueBasedTrigger'

class JobScheduleOptions implements IJobScheduleOptions {
  timeBasedTrigger: ITimeBasedTrigger
  odometerTrigger: IValueBasedTrigger
  machineHoursTrigger: IValueBasedTrigger  

  constructor(scheduleOptions?: any) {
    this.timeBasedTrigger = new TimeBasedTrigger(scheduleOptions?.timeBasedTrigger)
    this.odometerTrigger = new ValueBasedTrigger(scheduleOptions?.odometerTrigger)
    this.machineHoursTrigger = new ValueBasedTrigger(scheduleOptions?.machineHoursTrigger)
  }
}

export default JobScheduleOptions
